import React from 'react';
import { useTranslation } from 'react-i18next';
import { CloudCheck, History } from 'lucide-react';
import { formatTime } from '../../utils/clock';

// The small status line beside a visit section's Save button (round 9).
//   grey  "Draft saved 10:42 AM"    what is typed is safe on the server, but
//                                   not yet part of the visit's record
//   amber "Unsaved draft restored"  the box was refilled from a draft the
//                                   doctor never saved — it needs a decision
// Both offer "Discard draft", which throws the draft away and puts the saved
// value back: a draft that could only be committed would force a doctor to
// save text they no longer want.


function DraftChip({ section, chip, onDiscard, disabled = false }) {
    const { t } = useTranslation();
    if (!chip) return null;
    const restored = chip.kind === 'restored';
    const Icon = restored ? History : CloudCheck;
    return (
        <span className="inline-flex flex-wrap items-center gap-2 mr-auto">
            <span
                data-testid={`draft-chip-${section}`}
                data-kind={chip.kind}
                className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium ${restored
                    ? 'bg-amber-50 text-amber-800 border border-amber-200'
                    : 'bg-gray-100 text-gray-500 border border-gray-200'}`}
            >
                <Icon className="h-3 w-3" aria-hidden="true" />
                {restored
                    ? t('appointmentDraft.restored', 'Unsaved draft restored')
                    : t('appointmentDraft.saved_at', 'Draft saved {{time}}', { time: formatTime(chip.at) })}
            </span>
            {onDiscard && (
                <button
                    type="button"
                    data-testid={`draft-discard-${section}`}
                    disabled={disabled}
                    onClick={onDiscard}
                    className="text-[11px] font-medium text-gray-500 underline underline-offset-2 hover:text-[#2D8A8A] cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
                >
                    {t('appointmentDraft.discard', 'Discard draft')}
                </button>
            )}
        </span>
    );
}

export default DraftChip;
